<template>
  <div class="spread">
    <div class="flex spread-warp-all">
      <div class="spread-warp tui-box flex-1">
        <div class="warp-top">您的推广链接</div>
        <div class="warp-bottom">
          <div class="text">{{ valueUrl || '无' }}</div>
          <div class="btn-w-r-bg" @click="copyText(valueUrl)">
            <div class="btn-c-r">复制</div>
          </div>
        </div>
      </div>
      <div class="spread-warp flex-1">
        <div class="warp-top">您的推广码</div>
        <div class="warp-bottom">
          <div class="text">{{ valueCode || '无' }}</div>
          <div class="btn-w-r-bg" @click="copyText(valueCode)">
            <div class="btn-c-r">复制</div>
          </div>
        </div>
      </div>
    </div>
    <div class="spread-warp" v-if="$store.state.userInfo && $store.state.userInfo.invite_open == 1 && $store.state.userInfo.invite_promotion == 1">
      <div class="warp-top">我的推广数据</div>
      <div class="sel-bot warp-bottom">
        <ul>
          <li>
            <div class="selbot-name">我的下线</div>
            <div class="selbot-img">
              <span>{{ value1 }}</span>
              <!-- <span @click="goLonger">推广详情</span> -->
            </div>
          </li>
          <li>
            <div class="selbot-name">我的佣金</div>
            <div class="selbot-img">
              <span class="blue">{{ value3 }}</span>
            </div>
          </li>
          <li>
            <div class="selbot-name">佣金比列</div>
            <div class="selbot-img">
              <span class="blue">{{ value2 }}%</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="spread-warp" v-if="$store.state.userInfo && $store.state.userInfo.invite_open == 1 && $store.state.userInfo.invite_promotion == 1">
      <div class="warp-top">我的推广佣金</div>
      <div class="spread-table csgo-table">
        <el-table :data="tableData" border style="width: 100%" class="list-table">
          <el-table-column prop="name" label="用户名" />
          <el-table-column prop="recharge" label="充值金额" />
          <el-table-column prop="ratio" label="佣金比例">
            <template slot-scope="scope">
              {{scope.row.ratio}}%
            </template>
          </el-table-column>
          <el-table-column prop="total_money" label="获得充值佣金">
            <template slot-scope="scope">
              <span class="mess-span2">
                <!-- <img src="@/assets/images/money.png" class="money-img" /> -->
                <strong>{{ Number(scope.row.money).toFixed(2) }}</strong>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="充值时间" />
        </el-table>
      </div>
      <div class="csgo-page">
        <el-pagination background :pager-count="5" layout="prev, pager, next" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
        </el-pagination>
      </div>
    </div>
    <div class="spread-warp" v-if="$store.state.userInfo && $store.state.userInfo.invite_open == 1 && $store.state.userInfo.invite_promotion == 1">
      <div class="warp-top">我的下线</div>
      <div class="spread-table csgo-table">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="name" label="用户名称" align="center">
          </el-table-column>
          <el-table-column prop="recharge_sub" label="下级累计充值" align="center">
          </el-table-column>
          <el-table-column prop="commission_sub" label="下级累计佣金" align="center">
          </el-table-column>
          <el-table-column prop="recharge" label="累计充值" align="center">
          </el-table-column>
          <el-table-column prop="commission" label="累计佣金" align="center">
          </el-table-column>
          <el-table-column prop="source" label="绑定方式" align="center">
          </el-table-column>
          <el-table-column prop="create_time" label="绑定时间" align="center">
          </el-table-column>
          <el-table-column prop="total_money" label="下级人数 ">
            <template slot-scope="scope">
              <span class="look-btn" @click="goLonger(scope.row.id)">{{ scope.row.sub_count }}人查看</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="csgo-page">
        <el-pagination background :pager-count="5" layout="prev, pager, next" :current-page.sync="searchForm2.page" :total="searchForm2.totalSize" :page-size="searchForm2.limit" @current-change="currentChange2">
        </el-pagination>
      </div>
    </div>
    <SpreadLonger ref="SpreadLonger" />
  </div>
</template>

<script>
import SpreadLonger from "@/views/me/spread-longer.vue"
export default {
  components: { SpreadLonger },
  data() {
    return {
      valueUrl: "",
      valueCode: "",
      value1: 0,
      value2: 0,
      value3: 0,
      tableData: [],
      list: [],
      searchForm2: {
        totalSize: 0,
        page: 1,
        limit: 20,
      },
      searchForm: {
        days: 0,
        totalSize: 0,
        page: 1,
        limit: 20,
      },
    };
  },
  created() {
    this.getData()
    this.getList()
    this.getList2()
  },
  methods: {
    //挑战推广详情
    goLonger(id) {
      this.$refs['SpreadLonger'].toggle(id)
    },
    //我的推广链接和邀请码
    getData() {
      this.$doGet('/api/hall.Invite/info').then((res) => {
        this.valueUrl = res.data.invite_url
        this.valueCode = res.data.invite_code
      }).catch(() => { })
    },
    //我的下线7天/30天/今天/全部
    getList() {
      this.$doGet("/api/hall.Invite/offline", this.searchForm).then((res) => {
        let data = res.data;
        this.value1 = data.people_num
        this.value2 = data.ratio
        this.value3 = data.invite_commission
        this.searchForm.totalSize = data.count
        this.tableData = data.list
      }).catch(() => { })
    },
    currentChange2(val) {
      this.searchForm2.searchForm = val
      this.getList2()
    },
    getList2() {
      this.$doGet('/api/hall.Invite/offlineList', this.searchForm2).then((res) => {
        this.list = res.data.list
        this.searchForm2.totalSize = res.data.count
      }).catch(() => { })
    },
    //复制
    copyText(text) {
      var input = document.createElement("input"); // js创建一个input输入框
      input.value = text; // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    currentChange(val) {
      this.searchForm.searchForm = val
      this.getList1();
    }
  },
};
</script>

<style lang="less" scoped>
.spread {
  padding: 36px;
  .spread-warp {
    background-color: #2b2c37;
    background: #2b2e3c;
    border-radius: 8px;
    box-sizing: border-box;
    margin-bottom: 36px;
    .warp-top {
      line-height: 60px;
      font-size: 14px;
      color: #ffffff;
      border-bottom: 1px solid #404355;
      padding-left: 36px;
    }
    .warp-bottom {
      padding: 36px 0;
      text-align: center;
      .text {
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        line-height: 21px;
        margin-bottom: 16px;
        word-break: break-all;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .btn-w-r-bg {
        width: 160px;
        margin: 0 auto;
      }
    }
    &.tui-box {
      margin-right: 36px;
    }
    .sel-bot {
      ul {
        display: flex;
        justify-content: space-around;
        align-items: center;
        li {
          cursor: pointer;
          .selbot-name {
            font-size: 14px;
            color: #bbb9b9;
            margin-bottom: 8px;
          }
          .selbot-img {
            text-align: center;
            font-weight: bold;
            font-size: 26px;
            img {
              width: 24px;
              height: 24px;
            }
            span {
              color: #ffc400;
              &.blue {
                color: #00f7ff;
              }
            }
          }
        }
      }
    }
    .spread-table {
      padding: 15px 15px 0;
      box-sizing: border-box;
    }
  }
}
.look-btn {
  cursor: pointer;
}
</style>
